export default __webpack_public_path__ + "static/media/s3.e4240b4b.svg";